export const getSeparator = (separatorType, full= false) => {
  switch (separatorType) {
    case 1:
      return <div className={`mt-2 pb-2 border-t border-black ${full ? "w-full mt-2 mb-5" : "w-64"}`}/>
    case 2:
      return <div className={`h-2 border-t border-b border-black ${full ? "w-full mt-3 mb-8" : "w-64"}`}/>
    case 3:
      return <div className={`h-3 border-t-2 border-b-2 border-black ${full ? "w-full mt-4 mb-10" : "w-64"}`}/>
    default:
      return <div className={`h-12 ${full ? "w-full" : "w-64"}`}/>
  }
}